
import React from 'react';
import { Toggle } from '@/components/ui/toggle';
import { Check, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { LeadQuality } from '../types/LeadTypes';
import { FilterSection } from './FilterSection';

interface QualityFilterProps {
  leadQuality: LeadQuality[];
  onLeadQualityChange: (quality: LeadQuality) => void;
}

export const QualityFilter: React.FC<QualityFilterProps> = ({
  leadQuality,
  onLeadQualityChange
}) => {
  return (
    <FilterSection id="lead-quality-filter" label="Quality">
      <div className="flex w-full h-10">
        <Toggle
          variant="outline"
          pressed={leadQuality.includes('qualified')}
          onPressedChange={() => onLeadQualityChange('qualified')}
          className={cn(
            "flex items-center justify-center gap-1 border flex-1 rounded-r-none h-full",
            leadQuality.includes('qualified') 
              ? "bg-white border-input data-[state=on]:bg-white" 
              : "bg-gray-50 text-gray-500 border-input hover:bg-gray-100"
          )}
        >
          <Check className={cn(
            "h-4 w-4",
            leadQuality.includes('qualified') ? "text-green-500" : "text-gray-400"
          )} />
          <span className={leadQuality.includes('qualified') ? "text-black" : ""}>Qualified</span>
        </Toggle>
        
        <Toggle
          variant="outline"
          pressed={leadQuality.includes('disqualified')}
          onPressedChange={() => onLeadQualityChange('disqualified')}
          className={cn(
            "flex items-center justify-center gap-1 border flex-1 rounded-l-none border-l-0 h-full",
            leadQuality.includes('disqualified') 
              ? "bg-white border-input data-[state=on]:bg-white" 
              : "bg-gray-50 text-gray-500 border-input hover:bg-gray-100"
          )}
        >
          <X className={cn(
            "h-4 w-4",
            leadQuality.includes('disqualified') ? "text-red-500" : "text-gray-400"
          )} />
          <span className={leadQuality.includes('disqualified') ? "text-black" : ""}>Disqualified</span>
        </Toggle>
      </div>
    </FilterSection>
  );
};
